const FEATURES = [
  {
    icon: 'ri-book-read-line',
    title: '海量漫画资源',
    desc: '收录超过10万部韩漫、日漫、国漫作品，涵盖恋爱、热血、悬疑、古风等全品类，每日持续扩充。',
  },
  {
    icon: 'ri-arrow-down-line',
    title: '下拉式追更体验',
    desc: '独创下拉式阅读模式，无需翻页等待，一滑到底沉浸式追更，阅读节奏由你掌控。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全直达入口',
    desc: '香香漫画官网入口安全无广告，纯净阅读环境，保护你的隐私安全，放心追更每一部漫画。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端适配阅读',
    desc: '电脑、平板、手机全端完美适配，随时随地打开香香漫画网址即可畅读，便捷无忧。',
  },
  {
    icon: 'ri-refresh-line',
    title: '每日稳定更新',
    desc: '热门漫画每日准时更新，热门韩漫、人气日漫、精品国漫同步追更，绝不让你等太久。',
  },
];

export default function Features() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            平台优势
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
            为什么千万读者选择香香漫画？五大核心优势为你揭晓答案
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5 md:gap-6">
          {FEATURES.map((f, i) => (
            <div
              key={i}
              className="group p-5 md:p-6 bg-background-50 rounded-xl border border-background-200/50 hover:border-primary-200 transition-all duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${f.icon} text-xl`} />
              </div>
              <h3 className="mt-4 text-base font-semibold text-foreground-900 font-heading">
                {f.title}
              </h3>
              <p className="mt-2 text-sm text-foreground-500 leading-relaxed">
                {f.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}